module.exports = __webpack_public_path__ + "img/feature_buy_th.10b0dfad.png";